<template>
    <Header ueberschrift="What3Words" v-show="randVisible" />
    <div id="what3words" :class="randVisible ? 'margin' : 'noMargin'">
        <iframe src="https://what3words.com/birnb%C3%A4ume.durst.beweis" title="What3Words" :class="randVisible ? 'iframe':'fullscreen'"></iframe>


       <!-- <button v-if="1==2" id="controlButton" @click="switchMapControl()" class="fa">&#xf013;</button>
        <span id="mapControl" v-if="mapControlVisible">
            <button :class="randVisible ? 'buttonOn' : 'buttonOff'" @click="switchRandVisibility()">Rand</button>
        </span>-->
    </div>
    <!--<Footer backLink="/einsatz/" v-show="randVisible" />-->

    <!--<router-link :to="`/einsatz/`+this.$route.params.id"><button id="homeButton" class="mapButton"><img src="@/assets/Icons/HomeButton.svg"></button></router-link>-->
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import axios from 'axios'

export default {
    name: 'What3WordsView',
    components: {
        Header,
        Footer
    },
    data() {
        return {
            mapControlVisible: false,
            randVisible: false,
        }
    },
    created() {
        //this.getUser('sebastianpfuelb@gmail.com');
    },
    methods: {
        switchMapControl() {
            this.mapControlVisible = !this.mapControlVisible;
        },
        switchRandVisibility() {
            this.randVisible = !this.randVisible;
        },
    },
    created() {

    }
}
</script>

<style lang="scss">
#what3words {

    .iframe {
        width: 100vw;
        height: 89vh;
    }

    @media screen and (max-height: 768px) {
        iframe {
            height: 74vh !important;
        }
    }

    #controlButton {
        background-color: white !important;
        position: absolute !important;
        top: 15rem !important;
        right: 1.1rem !important;
        z-index: 1000 !important;
        padding: 0.5rem !important;
        border-radius: 7px !important;
    }

    #mapControl {
        background-color: white !important;
        position: absolute !important;
        top: 16.5rem !important;
        right: 2.6rem !important;
        z-index: 999 !important;
        padding: 1rem !important;
        border-radius: 7px !important;
        border: solid grey 1px;

        button {
            width: 100%;
            padding-top: 2px;
            padding-bottom: 2px;
            margin-top: 3px;
            margin-bottom: 3px;
            font-size: medium;
            padding-right: 3px;
            padding-left: 3px;
        }
    }
    .margin {
    display: block !important;
    position: absolute !important;
    height: auto !important;
    bottom: 0 !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
    //height: 72vh;
    }

    .noMargin {
    margin-top: 0rem !important;
    height: 100vh !important;
    }

    .fullscreen{
        width: 100vw !important;
        height: 100vh !important;
    }

    #homeButton{
        position: absolute;
        //bottom: -2.7rem;
        bottom: 1.5rem;
        left: 50%;
        transform: translateX(-50%);
    }

    .mapButton{
        width: 3.5rem;
        height: 3.5rem;
        box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.11);
        background-color: white;
        z-index: 400;
        border: none;
        border-radius: 90px;
        transition: transform 0.3s ease;

        img{
            height: 60%;
            margin: auto;
        }
    }
}
</style>
